const classAttackConfigs = [
  {
    id: 1,
    name: 'warrior',
    attackType: 'slice',
  },
  {
    id: 2,
    name: 'mage',
    attackType: 'lightning',
  },
  {
    id: 3,
    name: 'hunter',
    attackType: 'arrows',
  },
];

export default classAttackConfigs;
